import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  setIpmaCisProfileCreator,
  approveIpmaChangeRequestCreator,
  verifyIpmaChangeRequestCreator,
  implementIpmaChangeRequestCreator,
  loadGlobalCountriesCreator,
  loadGlobalAvailableMACreator,
} from '../../../../store/actionsCreators';
import ChangeRequest from '../../../../shared/ChangeRequest/ChangeRequest';

const mapStateToProps = ({ loading, ipma, globals, user }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma',
  list: ipma.cis.changeRequests,
  userPermissions: user.userPermissions,
  countries: globals.countries,
  memberAssociations: globals.availableMA,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('changeRequests')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('changeRequests', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('changeRequests', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('changeRequests', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('changeRequests', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('changeRequests')),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('changeRequests', payload)),
  verifyChangeRequest: (id, payload) =>
    dispatch(verifyIpmaChangeRequestCreator(id, payload)),
  approveChangeRequest: (id, payload) =>
    dispatch(approveIpmaChangeRequestCreator(id, payload)),
  implementChangeRequest: (id, payload) =>
    dispatch(implementIpmaChangeRequestCreator(id, payload)),
  loadAttributes: () => {
    dispatch(loadGlobalCountriesCreator());
    dispatch(loadGlobalAvailableMACreator({ showAll: true }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRequest);
